import React from 'react';

/**
 * Two-row filter bar (desktop + mobile) used at the top of Matches /
 * SavedMatches / HiddenMatches. Verbatim port of the bar JSX that lived
 * inline in Matches.jsx prior to this extraction.
 *
 * Ships its own responsive `<style>` block — the `.matches-filter-bar-*`
 * media queries used to live in the page-level <style> on Matches.jsx
 * (and don't exist at all on SavedMatches / HiddenMatches today). Bundling
 * them here makes the component self-contained.
 *
 * @param {object} props
 * @param {object} props.filters - Return object from `useMatchFilters`. Used:
 *   - categoryFilter, setCategoryFilter
 *   - openFilterSheet
 *   - activeFilterCount
 */
export default function MatchFilterBar({ filters }) {
  const {
    categoryFilter,
    setCategoryFilter,
    openFilterSheet,
    activeFilterCount
  } = filters;

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .matches-filter-bar-desktop { display: none !important; }
        }
      `}</style>
      {/* Desktop filter bar */}
      <div className="matches-filter-bar-desktop" style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '1100px', margin: '0 auto', width: '100%', paddingLeft: '2rem', paddingRight: '2rem', boxSizing: 'border-box' }}>
          <select
            id="matches-filter-select-desktop"
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
            style={{
              borderRadius: '30px',
              fontSize: '1.125rem',
              fontFamily: 'Nunito, sans-serif',
              fontWeight: '700',
              backgroundColor: 'white',
              color: '#374151',
              cursor: 'pointer',
              border: '1px solid #C89F3C',
              padding: '0.75rem 2.75rem 0.75rem 1.5rem',
              outline: 'none',
              appearance: 'none',
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23C89F3C' d='M6 8L0 0h12z'/%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 1rem center'
            }}
          >
            <option value="all">All</option>
            <option value="pedals">Pedals</option>
            <option value="accessories">Accessories</option>
          </select>
          <button
            onClick={openFilterSheet}
            style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              padding: '0.75rem 1.5rem',
              borderRadius: '30px',
              border: '1px solid #C89F3C',
              backgroundColor: activeFilterCount > 0 ? '#C89F3C' : 'white',
              color: activeFilterCount > 0 ? 'white' : '#374151',
              fontFamily: 'Nunito, sans-serif',
              fontWeight: '700',
              fontSize: '1.125rem',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/>
            </svg>
            Filter{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
          </button>
        </div>
      </div>
    </>
  );
}
